export default "/97c9550386c03973faff01b1571a81de.jpg";